/* unplugin-vue-components disabled */import script from "./MobileLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileLayout.vue?vue&type=script&lang=ts&setup=true"

import "./MobileLayout.vue?vue&type=style&index=0&id=00740cd9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00740cd9"]])

export default __exports__